var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "36.684px",
    viewBox: "0 0 55 36.684",
    enableBackground: "new 0 0 55 36.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M43.549,34.245H11.45V4.048h32.099V34.245z M12.95,32.745h29.099V5.548H12.95V32.745z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M42.8,11.944H12.2c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h30.6c0.414,0,0.75,0.336,0.75,0.75 S43.214,11.944,42.8,11.944z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.499,
    y: 2.438,
    fill: "#00A79D",
    width: 1.5,
    height: 4.909
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.999,
    y: 2.438,
    fill: "#00A79D",
    width: 1.5,
    height: 4.909
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.573,
    y: 15.915,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.096,
    y: 15.915,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.618,
    y: 15.915,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.051,
    y: 19.599,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.573,
    y: 19.599,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.096,
    y: 19.599,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.618,
    y: 19.599,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.051,
    y: 23.28,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.573,
    y: 23.28,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.096,
    y: 23.28,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.618,
    y: 23.28,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.051,
    y: 26.962,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.573,
    y: 26.962,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.096,
    y: 26.962,
    fill: "#00A79D",
    width: 2.33,
    height: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4d33bb61a149557f349e7ca995b54e5c.svg";
export { ForwardRef as ReactComponent };